import { render, staticRenderFns } from "./OnBoardingSelectGenres.vue?vue&type=template&id=de18b4fc&scoped=true&"
import script from "./OnBoardingSelectGenres.vue?vue&type=script&lang=js&"
export * from "./OnBoardingSelectGenres.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de18b4fc",
  null
  
)

export default component.exports